import React from 'react';
import NoteIcon from '@mui/icons-material/Note';
import styles from '../ConfirmedOfferPage.module.scss';

interface ShiftNotesPanelProps {
    notes: string | null;
}

export const ShiftNotesPanel: React.FC<ShiftNotesPanelProps> = ({ notes }) => {
    if (!notes || !notes.trim()) return null;
    
    return (
        <div className={styles.shiftNotesSection}>
            <div className={styles.shiftNotesHeader}>
                <div className={styles.shiftNotesIcon}>
                    <NoteIcon />
                </div>
                <h3 className={styles.shiftNotesTitle}>Shift Notes</h3>
            </div>
            <div className={styles.shiftNotesContent}>
                {notes}
            </div>
        </div>
    );
};

